<template>
  <div class="list-owe-fee-container">
    <div class="owe-fee-layout">
      <div class="tree-panel">
        <div class="tree-all" :class="{ 'is-active': !listOweFeeInfo.conditions.floorId && !listOweFeeInfo.conditions.unitId }"
          @click="selectAllFloors">全部</div>
        <floor-unit-tree ref="floorUnitTree" @switchFloorUnit="switchFloorUnit" />
      </div>
      <div class="content-panel">
    <!-- 查询条件 -->
    <el-card class="search-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('listOweFee.search.title') }}</span>
        <el-button type="text" style="float: right; padding: 3px 0" @click="toggleMoreCondition">
          {{ listOweFeeInfo.moreCondition ? $t('common.hide') : $t('common.more') }}
        </el-button>
      </div>
      <el-row :gutter="20">
        <el-col :span="5">
          <el-input v-model.trim="listOweFeeInfo.conditions.roomNum"
            :placeholder="$t('listOweFee.search.roomNum')"></el-input>
        </el-col>
        <el-col :span="5">
          <el-input v-model.trim="listOweFeeInfo.conditions.ownerName"
            :placeholder="$t('listOweFee.search.ownerName')"></el-input>
        </el-col>
        <el-col :span="5">
          <el-input v-model.trim="listOweFeeInfo.conditions.tenantName"
            :placeholder="$t('listOweFee.search.tenantName')"></el-input>
        </el-col>
        <el-col :span="4">
          <el-select v-model="listOweFeeInfo.conditions.payObjType" :placeholder="$t('listOweFee.search.payObjType')"
            style="width:100%">
            <el-option :label="$t('listOweFee.search.payObjType')" value=""></el-option>
            <el-option v-for="(item, index) in listOweFeeInfo.payObjTypes" :key="index" :label="item.name"
              :value="item.statusCd"></el-option>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-button type="primary" @click="queryOweFee">
            <i class="el-icon-search"></i>
            {{ $t('common.search') }}
          </el-button>
          <el-button type="info" @click="resetOweFee">
            <i class="el-icon-refresh"></i>
            {{ $t('common.reset') }}
          </el-button>
        </el-col>
      </el-row>

      <!-- 更多查询条件 -->
      <el-row v-show="listOweFeeInfo.moreCondition" :gutter="20">
        <el-col :span="6">
          <el-select v-model="listOweFeeInfo.conditions.roomSubType" :placeholder="$t('listOweFee.search.roomType')"
            style="width:100%">
            <el-option :label="$t('listOweFee.search.roomType')" value=""></el-option>
            <el-option v-for="(item, index) in listOweFeeInfo.roomSubTypes" :key="index" :label="item.name"
              :value="item.statusCd"></el-option>
          </el-select>
        </el-col>
        <el-col v-if="listOweFeeInfo.conditions.payObjType === '3333'" :span="6">
          <el-input v-model.trim="listOweFeeInfo.conditions.num"
            :placeholder="$t('listOweFee.search.roomNumFormat')"></el-input>
        </el-col>
        <el-col v-if="listOweFeeInfo.conditions.payObjType === '6666'" :span="6">
          <el-input v-model.trim="listOweFeeInfo.conditions.num"
            :placeholder="$t('listOweFee.search.carportNum')"></el-input>
        </el-col>
        <el-col :span="6">
          <el-select v-model="selectedFeeConfigs" multiple :placeholder="$t('listOweFee.search.feeConfig')"
            style="width:100%">
            <el-option v-for="(item, index) in listOweFeeInfo.feeConfigs" :key="index" :label="item.feeName"
              :value="item.configId"></el-option>
          </el-select>
        </el-col>
      </el-row>
    </el-card>

    <!-- 欠费信息表格 -->
    <el-card class="table-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('listOweFee.table.title') }}</span>
        <div class="table-actions">
          <el-button type="primary" size="small" icon="el-icon-upload2" @click="openOweFeeStandardImport">
            {{ $t('listOweFee.standardImport') }}
          </el-button>
          <el-button type="success" size="small" icon="el-icon-connection" @click="openOweFeeCustomImport">
            {{ $t('listOweFee.customImport') }}
          </el-button>
          <el-button type="info" size="small" icon="el-icon-data-analysis" @click="openHistoryOweFeeImport">
            历史欠费导入（测试）
          </el-button>
          <el-button type="warning" size="small" @click="batchPrintOweFee" :disabled="!selectedRows.length">
            <i class="el-icon-printer"></i>
            {{ $t('listOweFee.batchPrintOweFee') }}
          </el-button>
          <el-button type="danger" size="small" icon="el-icon-printer" @click="printCommunityDunning">
            打印小区催缴单
          </el-button>
          <el-button type="primary" size="small" @click="exportFee">
            <i class="el-icon-download"></i>
            {{ $t('common.export') }}
          </el-button>
        </div>
      </div>
      <el-dialog title="选择楼栋" :visible.sync="printFloorDialog" width="420px">
        <el-select v-model="selectedFloorId" placeholder="请选择楼栋(不选则默认打印全小区)" clearable style="width:100%">
          <el-option v-for="f in floorOptions" :key="f.floorId" :label="f.floorNum" :value="f.floorId" />
        </el-select>
        <div slot="footer">
          <el-button @click="printFloorDialog = false">取消</el-button>
          <el-button type="primary" @click="confirmPrintFloor">确定打印</el-button>
        </div>
      </el-dialog>
      <el-table :data="listOweFeeInfo.fees" border style="width: 100%" v-loading="loading"
        row-key="payerObjId"
        @sort-change="handleSortChange"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="50" align="center" reserve-selection></el-table-column>
        <el-table-column prop="index" :label="$t('listOweFee.table.index')" width="80" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="payerObjName" :label="$t('listOweFee.table.payerObjName')"
          sortable="custom"
          align="center"></el-table-column>
        <el-table-column prop="ownerName" :label="$t('listOweFee.table.ownerName')" sortable="custom" align="center"></el-table-column>
        <el-table-column prop="tenantNames" :label="$t('listOweFee.table.tenantNames')" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.tenantNames" class="owe-fee-payer-name">{{ scope.row.tenantNames }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="ownerTel" :label="$t('listOweFee.table.ownerTel')" align="center"></el-table-column>
        <el-table-column prop="endTime" :label="$t('listOweFee.table.endTime')" sortable="custom" align="center"></el-table-column>
        <el-table-column prop="deadlineTime" :label="$t('listOweFee.table.deadlineTime')"
          sortable="custom"
          align="center"></el-table-column>
        <el-table-column v-for="(item, index) in listOweFeeInfo.feeConfigNames" :key="index" :label="item.configName"
          align="center">
          <template slot-scope="scope">
            {{ getFeeOweAmount(item, scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="amountOwed" :label="$t('listOweFee.table.total')" sortable="custom" align="center">
          <template slot-scope="scope">
            {{ getAllFeeOweAmount(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" :label="$t('listOweFee.table.updateTime')" align="center"></el-table-column>
        <el-table-column :label="$t('listOweFee.table.operation')" width="90" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openRoomOweDetail(scope.row)">
              {{ $t('listOweFee.detail.btn') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page.current"
        :page-sizes="[10, 20, 30, 50]" :page-size="page.size" layout="total, sizes, prev, pager, next, jumper"
        :total="page.total" style="margin-top: 20px;"></el-pagination>

      <!-- 小计和合计 -->
      <div class="summary-wrapper">
        <div class="summary-item">
          <span class="summary-title">{{ $t('listOweFee.summary.subtotal') }}</span>
          <div v-for="(item, index) in listOweFeeInfo.feeConfigNames" :key="index" class="summary-content">
            {{ item.configName }}: {{ getFeeOweAllAmount(item) }} {{ $t('common.yuan') }}
          </div>
          <div class="summary-content">
            {{ $t('listOweFee.summary.total') }}: {{ getFeeOweAllAmounts() }} {{ $t('common.yuan') }}
          </div>
        </div>
      </div>
    </el-card>

      </div>
    </div>

    <!-- 欠费标准模板导入：固定表头，弹窗内下载模板 -->
    <excel-import-mapper
      ref="oweFeeStandardImportMapper"
      hide-trigger
      :title="$t('listOweFee.standardImportTitle')"
      :fields="oweFeeImportFields"
      :submit-handler="submitOweFeeImport"
      :adapt-file="adaptOweFeeImportFile"
      :template-download-handler="downloadOweFeeTemplate"
      :template-download-text="$t('listOweFee.downloadTemplate')"
      :show-default-value-column="false"
      :show-value-mapping-column="false"
      :show-source-column-select="false"
      :show-field-description="false"
      :show-source-data="false"
      :extra-data="getOweFeeImportExtraData"
      output-sheet-name="欠费数据"
      output-file-name="欠费导入-已匹配.xlsx"
      :max-file-size-mb="10"
      :max-data-rows="50000"
      :auto-close="false"
      :show-success-message="false"
      @success="handleOweFeeImportSuccess"
      @error="handleOweFeeImportError"
    />

    <!-- 欠费自定义导入：保留原始 Excel 列供手动匹配；宽表自动转换仅用于标准模板导入 -->
    <excel-import-mapper
      ref="oweFeeCustomImportMapper"
      hide-trigger
      :title="$t('listOweFee.customImportTitle')"
      :fields="oweFeeImportFields"
      :submit-handler="submitOweFeeImport"
      :show-source-data="true"
      :extra-data="getOweFeeImportExtraData"
      output-sheet-name="欠费数据"
      output-file-name="欠费导入-已匹配.xlsx"
      :max-file-size-mb="10"
      :max-data-rows="50000"
      :auto-close="false"
      :show-success-message="false"
      @success="handleOweFeeImportSuccess"
      @error="handleOweFeeImportError"
    />

    <el-dialog
      title="选择欠费导入类型"
      :visible.sync="oweFeeImportTargetDialogVisible"
      width="440px"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="owe-fee-import-target-selector">
        <span>本次导入只允许包含一种房屋类型</span>
        <el-radio-group v-model="oweFeeImportTargetType" size="medium">
          <el-radio-button label="ROOM">普通住宅</el-radio-button>
          <el-radio-button label="SHOP">商铺</el-radio-button>
        </el-radio-group>
      </div>
      <span slot="footer">
        <el-button @click="oweFeeImportTargetDialogVisible = false">取消</el-button>
        <el-button type="primary" :disabled="!oweFeeImportTargetType" @click="confirmOweFeeImportTarget">继续导入</el-button>
      </span>
    </el-dialog>

    <!-- 新版历史欠费兼容导入：测试入口，不替换现有标准及自定义导入 -->
    <history-owe-fee-import
      ref="historyOweFeeImport"
      :community-id="listOweFeeInfo.conditions.communityId"
      :fee-configs="listOweFeeInfo.feeConfigs"
      :submit-handler="submitHistoryOweFeeImport"
      @success="handleOweFeeImportSuccess"
      @error="handleOweFeeImportError"
    />

    <!-- 房屋欠费明细：当前业主 + 缴费人 -->
    <el-dialog
      :title="oweDetailTitle"
      :visible.sync="oweDetailVisible"
      width="90%"
      top="5vh"
      append-to-body
      @closed="resetOweDetail">
      <div class="owe-detail-header" v-loading="oweDetailLoading">
        <span>{{ $t('listOweFee.detail.room') }}：{{ oweDetail.payerObjName || '-' }}</span>
        <span>{{ $t('listOweFee.detail.currentOwner') }}：{{ oweDetail.currentOwnerName || '-' }}</span>
        <span>{{ $t('listOweFee.detail.currentOwnerTel') }}：{{ oweDetail.currentOwnerTel || '-' }}</span>
        <span>{{ $t('listOweFee.detail.lineCount') }}：{{ oweDetail.lineCount || 0 }}</span>
        <span>{{ $t('listOweFee.detail.totalAmount') }}：{{ oweDetail.totalAmount || '0.00' }}</span>
      </div>
      <el-table :data="oweDetail.lines" border stripe max-height="520" v-loading="oweDetailLoading">
        <el-table-column type="index" :label="$t('listOweFee.table.index')" width="60" align="center" />
        <el-table-column prop="feeName" :label="$t('listOweFee.detail.feeItem')" min-width="140" align="center" />
        <el-table-column prop="oweOwnerName" :label="$t('listOweFee.detail.oweOwner')" min-width="110" align="center" />
        <el-table-column prop="oweOwnerTel" :label="$t('listOweFee.detail.oweOwnerTel')" min-width="120" align="center" />
        <el-table-column prop="endTime" :label="$t('listOweFee.table.endTime')" width="110" align="center" />
        <el-table-column prop="deadlineTime" :label="$t('listOweFee.table.deadlineTime')" width="110" align="center" />
        <el-table-column prop="amountOwed" :label="$t('listOweFee.detail.amount')" width="100" align="center" />
      </el-table>
      <span slot="footer">
        <el-button type="primary" @click="oweDetailVisible = false">{{ $t('common.confirm') }}</el-button>
      </span>
    </el-dialog>

    <!-- 导入失败明细弹窗 -->
    <el-dialog
      :title="$t('listOweFee.importErrorTitle')"
      :visible.sync="importErrorVisible"
      width="860px"
      append-to-body
      :close-on-click-modal="false"
      @close="resolveImportOwnerConfirmation(false)"
    >
      <div class="import-error-tip">{{ importErrorSummary }}</div>
      <el-alert v-if="importOwnerConfirmation" type="warning" :closable="false"
        :title="$t('listOweFee.importOwnerMismatchTip')" show-icon />
      <el-table :data="importErrors" border max-height="420" style="width: 100%">
        <el-table-column prop="rowIndex" :label="$t('listOweFee.importErrorRow')" width="90" align="center" />
        <el-table-column prop="roomName" :label="$t('listOweFee.table.payerObjName')" width="140" align="center" show-overflow-tooltip />
        <el-table-column prop="ownerName" :label="$t('listOweFee.table.ownerName')" width="140" align="center" show-overflow-tooltip />
        <el-table-column prop="message" :label="$t('listOweFee.importErrorReason')" min-width="280" show-overflow-tooltip />
      </el-table>
      <span slot="footer">
        <el-button @click="resolveImportOwnerConfirmation(false)">
          {{ importOwnerConfirmation ? $t('common.cancel') : $t('common.confirm') }}
        </el-button>
        <el-button v-if="importOwnerConfirmation" type="primary" @click="resolveImportOwnerConfirmation(true)">
          {{ $t('listOweFee.continueImport') }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 导入成功弹窗 -->
    <el-dialog
      :title="$t('listOweFee.importSuccessTitle')"
      :visible.sync="importSuccessVisible"
      width="420px"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div class="import-success-content">
        <i class="el-icon-success import-success-icon" />
        <span>{{ importSuccessMessage }}</span>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="handleImportSuccessConfirm">{{ $t('common.confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getDict } from '@/api/community/communityApi'
import { getCommunityId } from '@/api/community/communityApi'
import {
  queryReportOweFee,
  listFeeConfigs,
  exportData,
  importOweFee,
  queryRoomOweFeeDetail
} from '@/api/fee/listOweFeeApi'
import FloorUnitTree from '@/components/room/floorUnitTree'
import HistoryOweFeeImport from '@/components/fee/HistoryOweFeeImport'
import { getFloorAndUnits } from '@/api/room/floorUnitTreeApi'
import { adaptOweFeeImportFile } from '@/views/fee/oweFeeImportAdapt'

const trimImportValue = value => {
  if (value === null || value === undefined || String(value).trim() === '') return ''
  return String(value).trim()
}

const OWE_FEE_IMPORT_TARGETS = {
  ROOM: '1010301',
  SHOP: '2020602'
}

const DEFAULT_IMPORT_SAMPLE = {
  roomName: '一期1-1-101',
  ownerName: '张三',
  ownerTel: '13800138000',
  feeConfigName: '物业管理费',
  configId: '请填写系统真实收费项目ID',
  oweAmount: '100.00',
  startTime: '2026-07-01',
  endTime: '2026-07-31',
  remark: '示例备注'
}

const toDateOnly = value => {
  const text = trimImportValue(value)
  if (!text) return ''
  const matched = text.match(/^(\d{4}-\d{2}-\d{2})/)
  return matched ? matched[1] : text
}

/** 有欠费列表时取第一条；否则用默认示例 */
const pickImportSampleOwner = fees => {
  const first = Array.isArray(fees) ? fees.find(item => item) : null
  if (!first) return { ...DEFAULT_IMPORT_SAMPLE }
  const firstItem = Array.isArray(first.items) ? first.items.find(item => item) : null
  return {
    roomName: trimImportValue(first.payerObjName) || DEFAULT_IMPORT_SAMPLE.roomName,
    ownerName: trimImportValue(first.ownerName) || DEFAULT_IMPORT_SAMPLE.ownerName,
    ownerTel: trimImportValue(first.ownerTel) || DEFAULT_IMPORT_SAMPLE.ownerTel,
    feeConfigName: trimImportValue(firstItem && (firstItem.feeName || firstItem.configName))
      || trimImportValue(first.configName)
      || DEFAULT_IMPORT_SAMPLE.feeConfigName,
    configId: trimImportValue(firstItem && firstItem.configId) || DEFAULT_IMPORT_SAMPLE.configId,
    oweAmount: trimImportValue(firstItem && firstItem.amountOwed)
      || trimImportValue(first.amountOwed)
      || DEFAULT_IMPORT_SAMPLE.oweAmount,
    startTime: toDateOnly(firstItem && firstItem.startTime)
      || toDateOnly(first.startTime)
      || DEFAULT_IMPORT_SAMPLE.startTime,
    endTime: toDateOnly(firstItem && firstItem.endTime)
      || toDateOnly(first.endTime)
      || DEFAULT_IMPORT_SAMPLE.endTime,
    remark: DEFAULT_IMPORT_SAMPLE.remark
  }
}

const isDynamicFeeConfig = item => String(item && item.computingFormula) === '4004'

const buildOweFeeImportFields = (feeConfigs, sampleOwner) => {
  // 可选值：罗列当前小区全部收费项（名称 / ID）；动态费用优先并标注可否导入
  const configs = (feeConfigs || []).filter(item => item && item.feeName && item.configId)
  const sample = { ...DEFAULT_IMPORT_SAMPLE, ...(sampleOwner || {}) }
  const sortedConfigs = configs.slice().sort((a, b) => Number(isDynamicFeeConfig(b)) - Number(isDynamicFeeConfig(a)))
  const feeNameOptions = sortedConfigs.map(item => {
    const importable = isDynamicFeeConfig(item)
    const shortLabel = `${item.feeName}（${item.configId}）`
    return {
      value: item.feeName,
      label: item.feeName,
      shortLabel,
      displayLabel: importable
        ? `${shortLabel}【动态费用·可导入】`
        : `${shortLabel}【非动态·不可导入】`,
      description: importable ? '动态费用，可按导入金额原样入账' : '非动态费用，导入金额会被公式重算，不可用于导入',
      tag: importable ? '动态费用·可导入' : '非动态·不可导入',
      tagType: importable ? 'success' : 'danger',
      importable,
      linkedDefaults: { configId: item.configId }
    }
  })
  const configIdOptions = sortedConfigs.map(item => {
    const importable = isDynamicFeeConfig(item)
    const shortLabel = `${item.configId}（${item.feeName}）`
    return {
      value: item.configId,
      label: item.feeName,
      shortLabel,
      displayLabel: importable
        ? `${shortLabel}【动态费用·可导入】`
        : `${shortLabel}【非动态·不可导入】`,
      description: importable ? '动态费用，可按导入金额原样入账' : '非动态费用，导入金额会被公式重算，不可用于导入',
      tag: importable ? '动态费用·可导入' : '非动态·不可导入',
      tagType: importable ? 'success' : 'danger',
      importable,
      linkedDefaults: { feeConfigName: item.feeName }
    }
  })
  // 示例优先：列表第一条且为动态费用 > 任一动态费用 > 列表第一条 > 默认值
  const dynamicConfigs = sortedConfigs.filter(isDynamicFeeConfig)
  const matchedFee = dynamicConfigs.find(item => item.configId === sample.configId)
    || dynamicConfigs.find(item => item.feeName === sample.feeConfigName)
    || dynamicConfigs[0]
    || configs.find(item => item.configId === sample.configId)
    || configs.find(item => item.feeName === sample.feeConfigName)
    || configs[0]
  const sampleFeeName = matchedFee ? matchedFee.feeName : sample.feeConfigName
  const sampleConfigId = matchedFee ? matchedFee.configId : sample.configId

  return [
    {
      key: 'roomName', label: '房屋信息', required: true,
      aliases: ['收费对象', '房间', '房屋', '房间编号', '房屋编号', '收费房间', '房屋编码', '期栋'],
      transform: trimImportValue,
      ruleItems: [
        '格式：期栋-单元-房号，须与系统房屋档案一致',
        `示例：${sample.roomName}`
      ],
      examples: [sample.roomName],
      rules: [
        { required: true, message: '房屋信息不能为空' },
        {
          validator(value) {
            const parts = String(value || '').split('-').map(item => String(item || '').trim())
            if (parts.length < 3 || parts.some(p => !p)) {
              return '房屋信息须为 期栋-单元-房号，如 一期1-1-101'
            }
            return true
          }
        }
      ]
    },
    {
      key: 'ownerName', label: '业主名称', required: true,
      aliases: ['业主', '客户名称', '联系人'],
      transform: trimImportValue,
      ruleItems: [
        '须与该房屋在系统中的业主名称完全一致',
        '与房屋信息一起校验；无手机号时须能唯一确定一名业主',
        `示例：${sample.ownerName}`
      ],
      examples: [sample.ownerName],
      rules: [
        { required: true, message: '业主名称不能为空' },
        {
          validator(value, ctx) {
            const roomName = ctx && ctx.values ? trimImportValue(ctx.values.roomName) : ''
            if (value && !roomName) {
              return '业主名称须与房屋信息一起填写，并对应系统同一房屋业主'
            }
            return true
          }
        }
      ]
    },
    {
      key: 'ownerTel', label: '手机号', required: false,
      aliases: ['联系电话', '电话', '手机号码', '业主电话', '联系方式'],
      transform: value => String(value || '').trim().split(/[\s,，;/]+/)[0] || '',
      ruleItems: [
        '选填；为空时按房屋信息+业主名称匹配，须唯一',
        '同一房屋多名同名业主时须填写手机号以区分',
        '有填写时不校验格式，支持占位符',
        `示例：${sample.ownerTel}`
      ],
      examples: [sample.ownerTel],
      rules: [
        {
          validator(value, ctx) {
            const roomName = ctx && ctx.values ? trimImportValue(ctx.values.roomName) : ''
            const ownerName = ctx && ctx.values ? trimImportValue(ctx.values.ownerName) : ''
            if (value && (!roomName || !ownerName)) {
              return '填写手机号时须同时填写房屋信息、业主名称'
            }
            return true
          }
        }
      ]
    },
    {
      key: 'feeConfigName', label: '收费项目', required: true,
      aliases: ['费用项目', '费用名称', '收费项', '费用类型', '商业物管费', '水电公摊费', '住户物管费'],
      transform: trimImportValue,
      ruleItems: [
        '须填写系统中已有的收费项名称',
        '须与「收费项目ID」成对一致',
        '仅可选「动态费用·可导入」；「非动态·不可导入」会因金额被公式重算而拒绝'
      ],
      valueOptions: feeNameOptions,
      examples: [sampleFeeName],
      rules: [
        { required: true, message: '收费项目不能为空' },
        {
          validator(value, ctx) {
            if (!configs.length) return '当前小区暂无收费项，请先维护收费项'
            const config = configs.find(item => item.feeName === String(value))
            if (!config) return `收费项目「${value}」在系统中不存在`
            const configId = ctx && ctx.values ? ctx.values.configId : ''
            if (configId && String(configId) !== String(config.configId)) {
              return `收费项目「${value}」与收费项目ID不匹配，正确ID为 ${config.configId}`
            }
            if (!isDynamicFeeConfig(config)) {
              return `收费项目「${value}」不是动态费用，无法按导入金额原样入账；请改用标有「动态费用·可导入」的收费项`
            }
            return true
          }
        }
      ]
    },
    {
      key: 'configId', label: '收费项目ID', required: true,
      aliases: ['费用项ID', 'configId', '收费项ID'],
      transform: trimImportValue,
      ruleItems: [
        '须填写系统中已有的收费项目ID',
        '须与「收费项目」成对一致',
        '仅「动态费用·可导入」可用于导入'
      ],
      valueOptions: configIdOptions,
      examples: [sampleConfigId],
      rules: [
        { required: true, message: '收费项目ID不能为空' },
        {
          validator(value, ctx) {
            if (!configs.length) return '当前小区暂无收费项，请先维护收费项'
            const config = configs.find(item => item.configId === String(value))
            if (!config) return `收费项目ID「${value}」在系统中不存在`
            const feeName = ctx && ctx.values ? ctx.values.feeConfigName : ''
            if (feeName && String(feeName) !== String(config.feeName)) {
              return `收费项目ID「${value}」对应名称为「${config.feeName}」，与填写的「${feeName}」不一致`
            }
            if (!isDynamicFeeConfig(config)) {
              return `收费项目ID「${value}」对应「${config.feeName}」不是动态费用，请改用标有「动态费用·可导入」的收费项`
            }
            return true
          }
        }
      ]
    },
    {
      key: 'oweAmount', label: '欠费金额', required: true,
      aliases: ['金额', '欠费金额(元)', '欠费', '欠款', '应收金额'],
      transform: trimImportValue,
      ruleItems: [
        '按 Excel 金额原样入账，不做面积/月份重算',
        '一行一条明细；列表合计 = 多条明细相加',
        '单位：元，必须大于 0',
        '收费项须为「动态费用」'
      ],
      examples: [sample.oweAmount],
      rules: [
        { required: true, type: 'number', min: 0.01, message: '欠费金额必须是大于 0 的数字' }
      ]
    },
    {
      key: 'startTime', label: '开始时间', required: true,
      aliases: ['欠费开始时间', '起始时间', '欠费起始', '开始日期', '费用开始时间'],
      transform: trimImportValue,
      ruleItems: [
        '格式：YYYY-MM-DD'
      ],
      examples: [sample.startTime],
      rules: [
        { required: true, message: '开始时间不能为空' },
        { pattern: /^\d{4}-\d{2}-\d{2}$/, message: '开始时间格式须为 YYYY-MM-DD' }
      ]
    },
    {
      key: 'endTime', label: '结束时间', required: true,
      aliases: ['欠费结束时间', '截止时间', '欠费截止', '结束日期', '缴费截止日期', '缴费截止', '费用结束时间'],
      transform: trimImportValue,
      ruleItems: [
        '格式：YYYY-MM-DD',
        '不能早于开始时间'
      ],
      examples: [sample.endTime],
      rules: [
        { required: true, message: '结束时间不能为空' },
        { pattern: /^\d{4}-\d{2}-\d{2}$/, message: '结束时间格式须为 YYYY-MM-DD' },
        {
          validator(value, ctx) {
            const start = ctx && ctx.values ? ctx.values.startTime : ''
            if (start && value && String(start) > String(value)) {
              return '开始时间不能晚于结束时间'
            }
            return true
          }
        }
      ]
    },
    {
      key: 'remark', label: '备注',
      aliases: ['说明', '备注信息', '其他'],
      transform: trimImportValue,
      ruleItems: [
        '选填，不超过 200 字',
        '同一房屋信息+业主+收费项目+账期有多条时，须用不同备注区分'
      ],
      examples: [sample.remark],
      rules: [
        {
          validator(value) {
            if (value && String(value).length > 200) return '备注不能超过 200 个字符'
            return true
          }
        }
      ]
    }
  ]
}

export default {
  name: 'ListOweFee',
  components: {
    FloorUnitTree,
    HistoryOweFeeImport
  },
  data() {
    return {
      loading: false,
      listOweFeeInfo: {
        fees: [],
        moreCondition: false,
        roomUnits: [],
        conditions: {
          configIds: '',
          payObjType: '',
          num: '',
          billType: '00123',
          floorId: '',
          floorName: '',
          roomNum: '',
          unitId: '',
          roomSubType: '',
          ownerName: '',
          tenantName: '',
          communityId: ''
        },
        feeConfigs: [],
        feeConfigNames: [],
        payObjTypes: [],
        roomSubTypes: []
      },
      selectedFeeConfigs: [],
      selectedRows: [],
      sortField: 'amountOwed',
      sortOrder: 'descending',
      userSorted: false,
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      oweFeeImportFields: buildOweFeeImportFields([], DEFAULT_IMPORT_SAMPLE),
      importErrorVisible: false,
      importErrorSummary: '',
      importErrors: [],
      importOwnerConfirmation: null,
      oweFeeImportTargetDialogVisible: false,
      pendingOweFeeImportMapperRef: '',
      oweFeeImportTargetType: '',
      oweFeeImportRoomType: '',
      importSuccessVisible: false,
      importSuccessMessage: '',
      printFloorDialog: false,
      floorOptions: [],
      selectedFloorId: '',
      oweDetailVisible: false,
      oweDetailLoading: false,
      oweDetail: {
        payerObjName: '',
        currentOwnerName: '',
        currentOwnerTel: '',
        lineCount: 0,
        totalAmount: '0.00',
        lines: []
      }
    }
  },
  computed: {
    oweDetailTitle() {
      const room = this.oweDetail.payerObjName
      return room
        ? `${this.$t('listOweFee.detail.title')}（${room}）`
        : this.$t('listOweFee.detail.title')
    }
  },
  created() {
    this.listOweFeeInfo.conditions.communityId = getCommunityId()
    this.initData()
  },
  beforeDestroy() {
    this.resolveImportOwnerConfirmation(false)
  },
  watch: {
    selectedFeeConfigs(newVal) {
      this.listOweFeeInfo.feeConfigNames = newVal.map(configId => {
        const config = this.listOweFeeInfo.feeConfigs.find(item => item.configId === configId)
        return {
          configId,
          configName: config ? config.feeName : ''
        }
      })
    },
    'listOweFeeInfo.feeConfigs': {
      deep: true,
      handler() {
        this.refreshOweFeeImportFields()
      }
    },
    'listOweFeeInfo.fees': {
      deep: true,
      handler() {
        this.refreshOweFeeImportFields()
      }
    }
  },
  methods: {
    refreshOweFeeImportFields() {
      const sample = pickImportSampleOwner(this.listOweFeeInfo.fees)
      this.oweFeeImportFields = buildOweFeeImportFields(this.listOweFeeInfo.feeConfigs, sample)
    },
    async initData() {
      try {
        this.loading = true
        await Promise.all([
          this.getPayObjTypes(),
          this.getRoomSubTypes(),
          this.loadListOweFeeInfo(),
          this.listFeeConfigs()
        ])
        this.refreshOweFeeImportFields()
      } catch (error) {
        console.error('初始化数据失败:', error)
      } finally {
        this.loading = false
      }
    },
    async getPayObjTypes() {
      try {
        const data = await getDict('report_owe_fee', 'payer_obj_type')
        this.listOweFeeInfo.payObjTypes = data
      } catch (error) {
        console.error('获取付费对象类型失败:', error)
      }
    },
    async getRoomSubTypes() {
      try {
        const data = await getDict('building_room', 'room_sub_type')
        this.listOweFeeInfo.roomSubTypes = data
      } catch (error) {
        console.error('获取房屋类型失败:', error)
      }
    },
    async loadListOweFeeInfo() {
      try {
        const params = {
          ...this.listOweFeeInfo.conditions,
          page: this.page.current,
          row: this.page.size,
          configIds: this.listOweFeeInfo.feeConfigNames.map(item => item.configId).join(','),
          sortField: this.sortField,
          sortOrder: this.sortOrder
        }
        const { data, total } = await queryReportOweFee(params)
        // 后端已按楼栋-单元-房号自然排序返回;仅当用户在前端主动点击表头排序时才做本地排序,否则保持接口顺序
        this.listOweFeeInfo.fees = this.userSorted ? this.sortFeeList(data || []) : (data || [])
        this.page.total = total
        this.refreshOweFeeImportFields()
      } catch (error) {
        console.error('获取欠费信息失败:', error)
      }
    },
    async listFeeConfigs() {
      try {
        const params = {
          page: 1,
          row: 200,
          isFlag: '0',
          communityId: this.listOweFeeInfo.conditions.communityId
        }
        const { data } = await listFeeConfigs(params)
        this.listOweFeeInfo.feeConfigs = data || []
        this.refreshOweFeeImportFields()
      } catch (error) {
        console.error('获取收费项失败:', error)
      }
    },
    toggleMoreCondition() {
      this.listOweFeeInfo.moreCondition = !this.listOweFeeInfo.moreCondition
    },
    queryOweFee() {
      this.page.current = 1
      this.loadListOweFeeInfo()
    },
    resetOweFee() {
      this.listOweFeeInfo.conditions = {
        configIds: '',
        payObjType: '',
        num: '',
        billType: '00123',
        floorId: '',
        floorName: '',
        roomNum: '',
        unitId: '',
        roomSubType: '',
        ownerName: '',
        tenantName: '',
        communityId: this.listOweFeeInfo.conditions.communityId
      }
      this.selectedFeeConfigs = []
      this.selectAllFloors()
    },
    getFeeOweAmount(item, fee) {
      if (!fee.items) return 0
      const found = fee.items.find(tmp => tmp.configId === item.configId)
      return found ? found.amountOwed : 0
    },
    getFeeOweAllAmount(item) {
      let amountOwed = 0.0
      this.listOweFeeInfo.fees.forEach(feeItem => {
        if (!feeItem.items) return
        feeItem.items.forEach(tmp => {
          if (tmp.configId === item.configId) {
            amountOwed += parseFloat(tmp.amountOwed)
          }
        })
      })
      return amountOwed.toFixed(2)
    },
    getAllFeeOweAmount(fee) {
      if (this.listOweFeeInfo.feeConfigNames.length < 1) {
        return fee.amountOwed
      }
      let amountOwed = 0.0
      this.listOweFeeInfo.feeConfigNames.forEach(feeItem => {
        if (!fee.items) return
        fee.items.forEach(item => {
          if (feeItem.configId === item.configId) {
            amountOwed += parseFloat(item.amountOwed)
          }
        })
      })
      return amountOwed.toFixed(2)
    },
    getFeeOweAllAmounts() {
      let amountOwed = 0.0
      this.listOweFeeInfo.fees.forEach(feeItem => {
        const rowAmount = this.getAllFeeOweAmount(feeItem)
        amountOwed += parseFloat(rowAmount)
      })
      return amountOwed.toFixed(2)
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection
    },
    resetOweDetail() {
      this.oweDetail = {
        payerObjName: '',
        currentOwnerName: '',
        currentOwnerTel: '',
        lineCount: 0,
        totalAmount: '0.00',
        lines: []
      }
    },
    async openRoomOweDetail(row) {
      if (!row || !row.payerObjId) {
        this.$message.warning(this.$t('listOweFee.detail.noRoom'))
        return
      }
      this.oweDetailVisible = true
      this.oweDetailLoading = true
      this.resetOweDetail()
      this.oweDetail.payerObjName = row.payerObjName || ''
      try {
        const res = await queryRoomOweFeeDetail({
          payerObjId: row.payerObjId,
          communityId: this.listOweFeeInfo.conditions.communityId || getCommunityId()
        })
        const data = (res && res.data) || res || {}
        this.oweDetail = {
          payerObjName: data.payerObjName || row.payerObjName || '',
          currentOwnerName: data.currentOwnerName || '',
          currentOwnerTel: data.currentOwnerTel || '',
          lineCount: data.lineCount || 0,
          totalAmount: data.totalAmount || '0.00',
          lines: Array.isArray(data.lines) ? data.lines : []
        }
      } catch (error) {
        console.error('加载房屋欠费明细失败:', error)
        this.$message.error(this.$t('listOweFee.detail.loadFailed'))
        this.oweDetailVisible = false
      } finally {
        this.oweDetailLoading = false
      }
    },
    batchPrintOweFee() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('listOweFee.batchPrintTip'))
        return
      }
      const payObjIds = this.selectedRows.map(row => row.payerObjId).join(',')
      const payObjType = this.selectedRows[0].payerObjType || '3333'
      const url = `/#/views/fee/printOweFee?payObjId=${payObjIds}&payObjType=${payObjType}`
      window.open(url)
    },

    printCommunityDunning() {
      this.selectedFloorId = ''
      this.loadPrintFloors()
      this.printFloorDialog = true
    },

    async loadPrintFloors() {
      try {
        const res = await getFloorAndUnits(getCommunityId())
        const floorMap = {}
        ;(res || []).forEach(item => {
          if (item.floorId && !floorMap[item.floorId]) {
            floorMap[item.floorId] = {
              floorId: item.floorId,
              floorNum: item.floorNum || item.floorName || ''
            }
          }
        })
        this.floorOptions = Object.values(floorMap)
      } catch (e) {
        this.floorOptions = []
        console.error('加载楼栋失败', e)
      }
    },

    confirmPrintFloor() {
      this.printFloorDialog = false
      const floorId = this.selectedFloorId
      const url = floorId
        ? `/#/views/fee/printCommunityOweFee?floorId=${floorId}`
        : '/#/views/fee/printCommunityOweFee'
      window.open(url)
    },

    async exportCommunityDunning() {
      try {
        const now = new Date()
        const pad = n => String(n).padStart(2, '0')
        const fileName = `${now.getFullYear()}-${pad(now.getMonth()+1)}-${pad(now.getDate())}_${pad(now.getHours())}-${pad(now.getMinutes())}-${pad(now.getSeconds())}_小区欠费催缴单.xlsx`
        const params = {
          communityId: getCommunityId(),
          pagePath: 'reportCommunityOweFee',
          fileName: fileName
        }
        await exportData(params)
        this.$message.success('催缴单已生成，请在下载中心查看')
        this.$router.push('/pages/property/downloadTempFile?tab=下载中心')
      } catch (error) {
        console.error('导出催缴单失败:', error)
        this.$message.error('导出催缴单失败')
      }
    },

    async exportFee() {
      try {
        const params = {
          ...this.listOweFeeInfo.conditions,
          pagePath: 'reportListOweFee',
          configIds: this.listOweFeeInfo.feeConfigNames.map(item => item.configId).join(',')
        }
        await exportData(params)
        this.$message.success(this.$t('common.operationSuccess'))
        this.$router.push('/pages/property/downloadTempFile?tab=下载中心')
      } catch (error) {
        console.error('导出失败:', error)
        this.$message.error(this.$t('listOweFee.exportError'))
      }
    },
    handleSizeChange(val) {
      this.page.size = val
      this.loadListOweFeeInfo()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.loadListOweFeeInfo()
    },
    handleSortChange({ prop, order }) {
      if (!order) {
        // 取消排序:恢复默认,由后端按楼栋-单元-房号自然排序返回
        this.sortField = 'amountOwed'
        this.sortOrder = 'descending'
        this.userSorted = false
        this.loadListOweFeeInfo()
        return
      }
      this.sortField = prop
      this.sortOrder = order
      this.userSorted = true
      this.listOweFeeInfo.fees = this.sortFeeList(this.listOweFeeInfo.fees)
    },
    sortFeeList(list) {
      const fees = Array.isArray(list) ? list.slice() : []
      const field = this.sortField || 'payerObjName'
      const direction = this.sortOrder === 'ascending' ? 1 : -1
      fees.sort((first, second) => {
        let result = 0
        if (field === 'amountOwed') {
          result = this.toSortNumber(this.getAllFeeOweAmount(first)) - this.toSortNumber(this.getAllFeeOweAmount(second))
        } else if (field === 'payerObjName') {
          // 楼栋-单元-房号 自然排序(按数字段比较),与后端一致
          result = this.compareRoomName(this.toSortText(first.payerObjName), this.toSortText(second.payerObjName))
        } else {
          result = this.toSortText(first[field]).localeCompare(this.toSortText(second[field]), 'zh-CN')
        }
        return result * direction
      })
      return fees
    },
    // 房屋名称(如 一期1-1-101) 自然排序: 按 楼栋-单元-房号 的数字段比较
    compareRoomName(first, second) {
      const left = first == null ? '' : String(first)
      const right = second == null ? '' : String(second)
      const leftParts = left.split('-')
      const rightParts = right.split('-')
      const len = Math.max(leftParts.length, rightParts.length)
      for (let i = 0; i < len; i++) {
        const lp = i < leftParts.length ? leftParts[i] : ''
        const rp = i < rightParts.length ? rightParts[i] : ''
        const cmp = this.compareAlphaNum(lp, rp)
        if (cmp !== 0) return cmp
      }
      return left.localeCompare(right, 'zh-CN')
    },
    // 比较一段(可能含文字和数字): 提取数字做数值比较, 数字相同再按原字符串比较
    compareAlphaNum(left, right) {
      const leftNum = this.extractDigits(left)
      const rightNum = this.extractDigits(right)
      if (!leftNum || !rightNum) {
        return String(left).localeCompare(String(right), 'zh-CN')
      }
      const cmp = parseFloat(leftNum) - parseFloat(rightNum)
      if (cmp !== 0) return cmp
      return String(left).localeCompare(String(right), 'zh-CN')
    },
    extractDigits(text) {
      if (text == null || text === '') return ''
      return String(text).replace(/[^0-9]/g, '')
    },
    toSortText(value) {
      return value == null ? '' : String(value)
    },
    toSortNumber(value) {
      const number = parseFloat(value)
      return Number.isNaN(number) ? 0 : number
    },
    selectAllFloors() {
      this.listOweFeeInfo.conditions.floorId = ''
      this.listOweFeeInfo.conditions.unitId = ''
      this.listOweFeeInfo.conditions.floorName = ''
      if (this.$refs.floorUnitTree && typeof this.$refs.floorUnitTree.clearCurrent === 'function') {
        this.$refs.floorUnitTree.clearCurrent()
      }
      this.page.current = 1
      this.loadListOweFeeInfo()
    },
    switchFloorUnit(data) {
      this.listOweFeeInfo.conditions.floorId = data.floorId || ''
      this.listOweFeeInfo.conditions.unitId = data.unitId || ''
      this.page.current = 1
      this.loadListOweFeeInfo()
    },
    openOweFeeImportMapper(refName) {
      this.refreshOweFeeImportFields()
      const openMapper = () => {
        const mapper = this.$refs[refName]
        if (mapper && typeof mapper.open === 'function') mapper.open()
      }
      if (!this.listOweFeeInfo.feeConfigs.length) {
        this.listFeeConfigs().finally(() => {
          this.refreshOweFeeImportFields()
          openMapper()
        })
        return
      }
      openMapper()
    },
    openOweFeeStandardImport() {
      this.chooseOweFeeImportTarget('oweFeeStandardImportMapper')
    },
    openOweFeeCustomImport() {
      this.chooseOweFeeImportTarget('oweFeeCustomImportMapper')
    },
    chooseOweFeeImportTarget(refName) {
      this.pendingOweFeeImportMapperRef = refName
      this.oweFeeImportTargetType = ''
      this.oweFeeImportRoomType = ''
      this.oweFeeImportTargetDialogVisible = true
    },
    confirmOweFeeImportTarget() {
      const roomType = OWE_FEE_IMPORT_TARGETS[this.oweFeeImportTargetType]
      if (!roomType || !this.pendingOweFeeImportMapperRef) return
      const refName = this.pendingOweFeeImportMapperRef
      this.oweFeeImportRoomType = roomType
      this.pendingOweFeeImportMapperRef = ''
      this.oweFeeImportTargetDialogVisible = false
      this.openOweFeeImportMapper(refName)
    },
    openHistoryOweFeeImport() {
      this.refreshOweFeeImportFields()
      const openImporter = () => {
        const importer = this.$refs.historyOweFeeImport
        if (importer && typeof importer.open === 'function') importer.open()
      }
      if (!this.listOweFeeInfo.feeConfigs.length) {
        this.listFeeConfigs().finally(openImporter)
        return
      }
      openImporter()
    },
    downloadOweFeeTemplate() {
      // 标准模板仅在「标准模板导入」弹窗内下载
      const link = document.createElement('a')
      link.href = '/import/importOweFee.xlsx'
      link.download = '欠费导入模板.xlsx'
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      this.$message.success(this.$t('listOweFee.downloadTemplateSuccess'))
    },
    adaptOweFeeImportFile,
    getOweFeeImportExtraData() {
      return {
        communityId: this.listOweFeeInfo.conditions.communityId,
        importTargetType: this.oweFeeImportTargetType,
        roomType: this.oweFeeImportRoomType
      }
    },
    async submitOweFeeImport(formData, context) {
      const importTargetType = trimImportValue(context && context.importTargetType) || this.oweFeeImportTargetType
      const roomType = trimImportValue(context && context.roomType) || this.oweFeeImportRoomType
      if (!OWE_FEE_IMPORT_TARGETS[importTargetType] || OWE_FEE_IMPORT_TARGETS[importTargetType] !== roomType) {
        const err = new Error('请先选择本次导入普通住宅或商铺')
        err.data = []
        throw err
      }
      const rows = (context.rows || []).map((row, index) => {
        const startTime = trimImportValue(row.startTime)
        const endTime = trimImportValue(row.endTime)
        return {
          rowIndex: index + 1,
          importTargetType,
          roomType,
          roomName: trimImportValue(row.roomName),
          ownerName: trimImportValue(row.ownerName),
          ownerTel: trimImportValue(row.ownerTel),
          feeConfigName: trimImportValue(row.feeConfigName),
          configId: trimImportValue(row.configId),
          oweAmount: trimImportValue(row.oweAmount),
          startTime,
          endTime,
          // 列表「结束时间」对应 deadlineTime；未单独填时用结束时间
          deadlineTime: endTime,
          remark: trimImportValue(row.remark)
        }
      })

      if (!rows.length) {
        const err = new Error(this.$t('listOweFee.importEmpty'))
        err.data = []
        throw err
      }

      const payload = {
        communityId: this.listOweFeeInfo.conditions.communityId,
        importTargetType,
        roomType,
        rows
      }
      let response = await importOweFee(payload)
      let errorsShown = false
      const canIgnoreOwnerMismatch = response && Number(response.code) !== 0 &&
        Array.isArray(response.data) && response.data.length > 0 &&
        response.data.every(item => item.errorCode === 'OWNER_NAME_MISMATCH' && item.canIgnore === true)
      if (canIgnoreOwnerMismatch) {
        const confirmed = await new Promise(resolve => {
          this.importOwnerConfirmation = resolve
          this.showImportErrors(response.msg, response.data)
        })
        errorsShown = !confirmed
        if (confirmed) {
          response = await importOweFee({ ...payload, ignoreOwnerNameMismatch: true })
        }
      }

      if (response && Number(response.code) !== 0) {
        const errors = Array.isArray(response.data) ? response.data : []
        if (!errorsShown) this.showImportErrors(response.msg || this.$t('listOweFee.importFailed'), errors)
        const err = new Error(response.msg || this.$t('listOweFee.importFailed'))
        err.importErrorsShown = true
        err.code = response.code
        err.data = errors
        err.result = response
        throw err
      }
      return response
    },
    resolveImportOwnerConfirmation(confirmed) {
      const resolve = this.importOwnerConfirmation
      this.importOwnerConfirmation = null
      this.importErrorVisible = false
      if (resolve) resolve(confirmed === true)
    },
    async submitHistoryOweFeeImport(payload) {
      return this.submitOweFeeImport(null, {
        importTargetType: payload && payload.importTargetType,
        roomType: payload && payload.roomType,
        rows: (payload && payload.rows) || []
      })
    },
    showImportErrors(summary, errors) {
      this.importErrorSummary = summary || this.$t('listOweFee.importFailed')
      this.importErrors = (errors || []).map(item => ({
        rowIndex: item.rowIndex || item.row || '-',
        roomName: item.roomName || '',
        ownerName: item.ownerName || '',
        message: item.message || item.msg || ''
      }))
      this.importErrorVisible = true
    },
    handleOweFeeImportError(error) {
      if (error && error.importErrorsShown) return
      const errors = error && error.data
      if (Array.isArray(errors) && errors.length) {
        this.showImportErrors(error.message || error.msg || this.$t('listOweFee.importFailed'), errors)
      }
    },
    async handleOweFeeImportSuccess(response) {
      const data = response && response.data
      const logId = data && data.logId
      const count = data && data.successCount
      ;['oweFeeStandardImportMapper', 'oweFeeCustomImportMapper'].forEach(refName => {
        const mapper = this.$refs[refName]
        if (!mapper || !mapper.dialogVisible) return
        mapper.dialogVisible = false
      })
      await this.$nextTick()
      if (logId) {
        this.$message.success(this.$t('listOweFee.importAccepted', { count: count || 0 }))
        this.$router.push({
          path: '/views/system/assetImportLogDetail',
          query: {
            logId,
            logType: (data && data.logType) || 'importOweFee'
          }
        })
        return
      }
      this.importSuccessMessage = count
        ? this.$t('listOweFee.importSuccessCount', { count })
        : this.$t('common.operationSuccess')
      this.importSuccessVisible = true
    },
    handleImportSuccessConfirm() {
      this.importSuccessVisible = false
      this.loadListOweFeeInfo()
    }
  }
}
</script>

<style lang="scss" scoped>
.list-owe-fee-container {
  padding: 20px;

  .owe-fee-payer-name {
    color: #f56c6c;
    margin-left: 4px;
  }

  .owe-fee-layout {
    display: flex;
    align-items: flex-start;
    gap: 12px;
  }

  .tree-panel {
    flex: 0 0 220px;
    max-height: calc(100vh - 140px);
    overflow-y: auto;
    background: #fff;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    padding: 10px;
  }

  .tree-all {
    margin-bottom: 8px;
    padding: 6px 10px;
    border-radius: 4px;
    color: #303133;
    cursor: pointer;

    &:hover,
    &.is-active {
      color: #409eff;
      background: #ecf5ff;
    }
  }

  .content-panel {
    flex: 1;
    min-width: 0;
  }

  .search-card {
    margin-bottom: 20px;

    .search-item {
      margin-bottom: 15px;
    }
  }

  .table-card {
    margin-bottom: 20px;
  }

  .summary-wrapper {
    margin-top: 20px;
    padding: 15px;
    background-color: #f5f7fa;
    border-radius: 4px;

    .summary-item {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
    }

    .summary-title {
      font-weight: bold;
      margin-right: 20px;
    }

    .summary-content {
      margin-right: 30px;
      margin-bottom: 10px;
    }
  }

  .import-error-tip {
    margin-bottom: 12px;
    color: #f56c6c;
    line-height: 1.5;
  }

  .import-success-content {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 0 4px;
    font-size: 15px;
    line-height: 1.6;
    color: #303133;
  }

  .import-success-icon {
    font-size: 28px;
    color: #67c23a;
    flex-shrink: 0;
  }

  .table-actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 8px;

    .el-button + .el-button {
      margin-left: 0;
    }
  }
}
</style>

<style lang="scss">
/* append-to-body 弹窗在组件外，需非 scoped */
.owe-detail-header {
  display: flex;
  flex-wrap: wrap;
  gap: 16px 24px;
  margin-bottom: 12px;
  padding: 10px 12px;
  background: #f5f7fa;
  border-radius: 4px;
  color: #303133;
  font-size: 14px;
}

.owe-fee-import-target-selector {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  padding: 8px 0 12px;
  color: #606266;
}
</style>
